module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (138).5c3f0507.jpg";